/* eslint-disable react/jsx-filename-extension */

import { Fade } from "react-awesome-reveal";
// import Team from 'assets/images/about.png';

import React from "react";

const HeroTeam = () => (
  <section className="hero sm:items-center lg:items-start sm:flex-row relative bg-gradient-to-r from-blue-500 to-purple-600 py-16">
    <div
      className="absolute inset-0 bg-cover bg-center opacity-50"
      style={{ backgroundImage: "url(your-image-url-here.jpg)" }}
    />
    <div className="container mx-auto relative z-10 px-6 lg:px-12">
      <Fade bottom>
        <div className="text-center lg:text-left">
          <h2 className="text-white text-4xl font-bold mb-6 animate__animated animate__fadeIn">
            Transform Your Business with Cutting-Edge Technology
          </h2>
          <p className="font-light text-xl text-gray-200 leading-relaxed mb-4 animate__animated animate__fadeIn animate__delay-1s">
            At <span className="text-white font-semibold">TTP TECH LLC</span>,
            we specialize in providing scalable, technology-driven solutions
            that empower businesses to grow. Whether it's through content
            repurposing, AI automations, custom-built apps, or comprehensive
            monthly subscriptions, we help you break through the noise.
          </p>
          <p className="font-light text-xl text-gray-200 leading-relaxed mb-4 animate__animated animate__fadeIn animate__delay-2s">
            Our monthly subscriptions offer ongoing updates and support, keeping
            your digital presence up-to-date with the latest features and
            optimizations. We also manage Facebook marketing campaigns, ensuring
            that your business is always in front of the right audience with
            high-converting ads.
          </p>
          <div className="flex justify-center lg:justify-start mb-8 animate__animated animate__fadeIn animate__delay-3s">
            <button
              className="px-8 py-3 bg-white text-gray-800 text-xl font-semibold rounded-full shadow-lg transform hover:scale-105 transition-transform duration-300"
              type="button"
              onClick={() =>
                (window.location.href =
                  "https://www.ttptechllc.com/discuss-project")
              }
            >
              Discuss Your Project
            </button>
          </div>
          <div className="lg:flex lg:space-x-12 lg:items-center mt-12">
            <div className="lg:w-1/4 text-center lg:text-left animate__animated animate__fadeIn animate__delay-4s">
              <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300">
                <i className="fas fa-cogs text-3xl text-indigo-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">AI Automations</h3>
                <p className="text-gray-600">
                  Streamline your business with custom AI-driven solutions that
                  reduce manual tasks, saving you time and resources.
                </p>
              </div>
            </div>
            <div className="lg:w-1/4 text-center lg:text-left animate__animated animate__fadeIn animate__delay-5s">
              <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300">
                <i className="fas fa-laptop-code text-3xl text-indigo-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">
                  Web & App Development
                </h3>
                <p className="text-gray-600">
                  Build custom websites and mobile apps that are not only
                  visually appealing but also optimized for performance.
                </p>
              </div>
            </div>
            <div className="lg:w-1/4 text-center lg:text-left animate__animated animate__fadeIn animate__delay-6s">
              <button
                className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300"
                type="button"
                onClick={() => (window.location.href = "/content-creation")}
              >
                <i className="fas fa-retweet text-3xl text-indigo-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">
                  Content Repurposing & Graphic Design
                </h3>
                <p className="text-gray-600">
                  Transform your long-form content into bite-sized,
                  high-engagement short-form pieces tailored for social media
                  platforms.
                </p>
              </button>
            </div>

            <div className="lg:w-1/4 text-center lg:text-left animate__animated animate__fadeIn animate__delay-7s">
              <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transform transition-all duration-300">
                <i className="fas fa-calendar text-3xl text-indigo-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">
                  Monthly Subscription
                </h3>
                <p className="text-gray-600">
                  Stay ahead with our monthly subscription plans that provide
                  continuous updates, support, and optimized Facebook marketing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </div>
  </section>
);

export default HeroTeam;
